'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
type IssueOfferFlowProps = {
  isLookupPending: boolean;
  isPending: boolean;
};
export function IssueOfferFlow(t0) {
  const $ = _c(3);
  const {
    isLookupPending,
    isPending
  } = t0;
  let t1;
  if ($[0] !== isLookupPending || $[1] !== isPending) {
    t1 = <Button size="lg" type="submit" className="w-full" disabled={isLookupPending} loading={isPending}>Wystaw ofertę i wyślij e-mail</Button>;
    $[0] = isLookupPending;
    $[1] = isPending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}